// Client-side numerology — no backend, no external API.

// Reduce a number to a single digit, preserving master numbers 11 / 22 / 33.
export function reduceNumber(n, allowMaster = true) {
  let value = Math.abs(Number(n) || 0);
  while (value > 9 && !(allowMaster && (value === 11 || value === 22 || value === 33))) {
    value = String(value)
      .split("")
      .reduce((sum, digit) => sum + Number(digit), 0);
  }
  return value;
}

// Life Path from a 'YYYY-MM-DD' string using the reduce-then-sum method.
export function lifePathFromDate(dateStr) {
  if (!dateStr) return null;
  const parts = dateStr.split("-").map(Number);
  if (parts.length !== 3 || parts.some((p) => Number.isNaN(p))) return null;
  const [year, month, day] = parts;
  const total = reduceNumber(month) + reduceNumber(day) + reduceNumber(year);
  return reduceNumber(total);
}

// Pythagorean letter values for the Expression (Name Vibration) number.
const LETTER_VALUES = {
  a: 1, j: 1, s: 1,
  b: 2, k: 2, t: 2,
  c: 3, l: 3, u: 3,
  d: 4, m: 4, v: 4,
  e: 5, n: 5, w: 5,
  f: 6, o: 6, x: 6,
  g: 7, p: 7, y: 7,
  h: 8, q: 8, z: 8,
  i: 9, r: 9,
};

// Expression / Name Vibration number from a name string (client-side only).
export function expressionFromName(name) {
  if (!name) return null;
  const letters = name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z]/g, "")
    .split("");
  if (letters.length === 0) return null;
  const total = letters.reduce((sum, ch) => sum + (LETTER_VALUES[ch] || 0), 0);
  if (total === 0) return null;
  return reduceNumber(total);
}

